interface Notification {
    id: number;
    type: 'success' | 'error' | 'warning' | 'info' | 'message';
    message: string;
}

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('notification-container');
    if (!container) return;

    const rawData = container.getAttribute('data-notifications');

    if (rawData) {
        const notifications: Notification[] = JSON.parse(rawData);
        notifications.forEach((n, index) => showNotification(n, index));
    }

    // Helper to create and display a notification element
    function showNotification(notification: Notification, index = 0) {
        const el = createNotificationElement(notification);
        //@ts-ignore
        container.appendChild(el);

        // Animate entry
        setTimeout(() => {
            el.classList.remove('translate-x-full', 'opacity-0', 'scale-95');
            el.classList.add('translate-x-0', 'opacity-100', 'scale-100');
        }, 50 + index * 100);

        // Auto-remove after 7s
        setTimeout(() => removeNotification(el), 7000);
    }

    function createNotificationElement(notification: Notification): HTMLElement {
        const wrapper = document.createElement('div');
        wrapper.className = `
            transform transition-all duration-500 ease-in-out
            translate-x-full opacity-0 scale-95
            max-w-sm w-full border-l-4 shadow-lg rounded-xl pointer-events-auto
            mb-3
            ${getBackground(notification.type)}
        `;
        wrapper.innerHTML = `
            <div class="p-4 flex items-center">
                <div class="flex-shrink-0">${getIcon(notification.type)}</div>
                <div class="ml-3 flex-1">
                    <p class="break-words" data-notification-message></p>
                </div>
                <div class="ml-4 flex-shrink-0">
                    <button class="inline-flex text-gray-400 hover:text-gray-500 focus:outline-none">&times;</button>
                </div>
            </div>
        `;
        // Messages often hold user input or exception text, so they are shown as text, never as HTML
        const message = wrapper.querySelector('[data-notification-message]');
        if (message) {
            message.textContent = notification.message;
        }
        //@ts-ignore
        wrapper.querySelector('button')?.addEventListener('click', () => removeNotification(wrapper));
        return wrapper;
    }

    function removeNotification(el: HTMLElement) {
        el.classList.remove('translate-x-0', 'opacity-100', 'scale-100');
        el.classList.add('translate-x-full', 'opacity-0', 'scale-95');
        setTimeout(() => el.remove(), 500);
    }

    function getBackground(type: Notification['type']): string {
        switch (type) {
            case 'success':
                return 'notification-success bg-white border-green-500 text-gray-800';
            case 'error':
                return 'bg-red-50 border-red-500 text-red-800';
            case 'warning':
                return 'bg-yellow-50 border-yellow-500 text-yellow-800';
            default:
                return 'bg-blue-50 border-blue-500 text-blue-800';
        }
    }

    function getIcon(type: Notification['type']): string {
        switch (type) {
            case 'success':
                return `<svg class="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clip-rule="evenodd"/></svg>`;
            case 'error':
                return `<svg class="w-5 h-5 text-red-500" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd"/></svg>`;
            case 'warning':
                return `<svg class="w-5 h-5 text-yellow-500" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/></svg>`;
            default:
                return `<svg class="w-5 h-5 text-blue-500" fill="currentColor" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/></svg>`;
        }
    }

    // ===== Livewire dynamic notifications =====
    window.addEventListener('notification', (event: any) => {
        const detail = event.detail;
        const notifications = !Array.isArray(detail) ? [detail] : detail;

        notifications.forEach((n: Notification) => {
            showNotification(n);
        });
    })
});
